import { render, staticRenderFns } from "./EiNum.vue?vue&type=template&id=6c53e82d&scoped=true&"
import script from "./EiNum.vue?vue&type=script&lang=js&"
export * from "./EiNum.vue?vue&type=script&lang=js&"
import style0 from "./EiNum.vue?vue&type=style&index=0&id=6c53e82d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c53e82d",
  null
  
)

export default component.exports